import {
    Bike,
    Hash,
    CreditCard,
    FileText,
    Shield,
    ExternalLink,
} from "lucide-react";

import "./VehicleCard.css";

function VehicleCard({ partner }) {

    const vehicle = partner.vehicle || {};

    const openDocument = (url) => {

        if (url) {
            window.open(url, "_blank");
        }

    };

    return (

        <div className="vehicle-card">

            <div className="card-title">

                <h3>Vehicle Information</h3>

            </div>

            <div className="vehicle-details">

                <div className="vehicle-item">

                    <Bike size={20} />

                    <div>

                        <span>Vehicle Type</span>

                        <strong>
                            {vehicle.vehicleType || "-"}
                        </strong>

                    </div>

                </div>

                <div className="vehicle-item">

                    <Hash size={20} />

                    <div>

                        <span>Vehicle Number</span>

                        <strong>
                            {vehicle.vehicleNumber || "-"}
                        </strong>

                    </div>

                </div>

                <div className="vehicle-item">

                    <CreditCard size={20} />

                    <div>

                        <span>Driving License</span>

                        <strong>

                            {vehicle.drivingLicense
                                ? (
                                    <button
                                        className="doc-btn"
                                        onClick={() =>
                                            openDocument(
                                                vehicle.drivingLicense
                                            )
                                        }
                                    >

                                        View

                                        <ExternalLink size={15} />

                                    </button>
                                )
                                : "-"}

                        </strong>

                    </div>

                </div>

                <div className="vehicle-item">

                    <FileText size={20} />

                    <div>

                        <span>RC Book</span>

                        <strong>

                            {vehicle.rcBook
                                ? (
                                    <button
                                        className="doc-btn"
                                        onClick={() =>
                                            openDocument(
                                                vehicle.rcBook
                                            )
                                        }
                                    >

                                        View

                                        <ExternalLink size={15} />

                                    </button>
                                )
                                : "-"}

                        </strong>

                    </div>

                </div>

                <div className="vehicle-item">

                    <Shield size={20} />

                    <div>

                        <span>Insurance</span>

                        <strong>

                            {vehicle.insurance
                                ? (
                                    <button
                                        className="doc-btn"
                                        onClick={() =>
                                            openDocument(
                                                vehicle.insurance
                                            )
                                        }
                                    >

                                        View

                                        <ExternalLink size={15} />

                                    </button>
                                )
                                : "-"}

                        </strong>

                    </div>

                </div>

            </div>

        </div>

    );

}

export default VehicleCard;